import type { GeneratedPackageSettings } from '@ms-cloudpack/common-types';

/**
 * Compare generated package settings for array sorting.
 */
export function compareSettings(a: GeneratedPackageSettings, b: GeneratedPackageSettings): number {
  // TypeScript's type narrowing doesn't work well with object properties,
  // so we can assign them to variables to help it out.
  const aMatch = a.match;
  const bMatch = b.match;

  // Place string matches at the beginning of the list.
  const isAString = typeof aMatch === 'string';
  const isBString = typeof bMatch === 'string';
  if (isAString || isBString) {
    return isAString ? (isBString ? aMatch.localeCompare(bMatch) : -1) : 1;
  }

  return aMatch.name.localeCompare(bMatch.name) || aMatch.version.localeCompare(bMatch.version);
}
